/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.com>
 */
import 'APP_THEME/_common/legacy/core.mobile';

import 'APP_THEME/default/rgbcmyk/index.less';

import 'APP_THEME/_common/selectboxit/index';

var list = $('#product-group-jump-list');
list.selectBoxIt({ autoWidth: false });
list.on('change', function() {
    $('#product-group-jump-button').attr('href', $('option:selected', this).data('target'));
});
